import axios from 'axios';
import { APP_REFERER } from '../../constants';
import { createAxiosInstance } from './create-instance';
import { t } from '../../helpers';
import { createGuestAxiosInstance } from './create-guest-instance';

export const PAYROLLR_API = createAxiosInstance(
  process.env['NX_PAYROLLR_API_URL'] as string,
  APP_REFERER.PAYROLLR,
  t,
);
export const PAYROLLR_GUEST_API = createGuestAxiosInstance(
  process.env['NX_PAYROLLR_API_URL'] as string,
  t,
);
export const ACCOUNTS_API = createAxiosInstance(
  process.env['NX_ACCOUNTS_API_URL'] as string,
  APP_REFERER.ACCOUNTS,
  t,
);
export const AUTH_API = createAxiosInstance(
  process.env['NX_AUTH_API_URL'] as string,
  undefined,
  t,
);
export const EDECLARATION_API = createAxiosInstance(
  process.env['NX_EDECLARATION_API_URL'] as string,
  undefined,
  t,
);

// for simple axios calls
export const AXIOS_INSTANCE = axios;

/**
 * Create an instance of the API for the specified app name.
 * @param {APP_REFERER} appName - The name of the app.
 * @returns {AxiosInstance} An instance of the API.
 */
export const GetAuthAPI = (appName?: APP_REFERER) =>
  createAxiosInstance(process.env['NX_AUTH_API_URL'] as string, appName);
